import { render, staticRenderFns } from "./change-status.vue?vue&type=template&id=68f4eda2&"
import script from "./change-status.vue?vue&type=script&lang=ts&"
export * from "./change-status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports